import * as React from "react"
import { Button, Icon } from "semantic-ui-react"
import { FieldType } from "../../../models"

interface IButtonLockProps {
  code: string
  lock: "lock" | "unlock"
  lockable: boolean
  hidden: boolean
  classes?: IClasseNames
  disabled?: boolean
  fieldType: FieldType
  onClick: (e: any, fieldType: FieldType) => void
}

interface IClasseNames {
  lock: string
  unlock: string
}

const ButtonLock = (props: IButtonLockProps) => {
  const {
    lock,
    lockable,
    onClick,
    hidden,
    code,
    classes,
    fieldType,
    disabled = false,
  } = props
  const usedClasses = classes || { lock: "lock", unlock: "unlock" }

  const onClickLock = (e: any) => {
    onClick(e, fieldType)
  }

  return (
    (!hidden && (
      <Button
        disabled={!lockable || disabled}
        basic={!lockable}
        name={code}
        style={{ width: "initial" }}
        className={
          (lock === "lock" ? usedClasses.lock : usedClasses.unlock) +
          " " +
          "locking-button"
        }
        color="black"
        value={lock}
        onClick={onClickLock}
        type="button"
      >
        <Icon name={lock} className="lock-icon" />
      </Button>
    )) || <></>
  )
}

export default ButtonLock
